import * as React from 'react';
import {connect} from "react-redux";
import {Notification, NotificationDescriptor} from "../../models/Notification";
import {ApplicationState} from "../../store";
import {NotificationList}  from '../components/NotificationList';
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {
	actionNotificationFetchAll,
	actionNotificationDelete,
	actionDeleteNotifications,
	actionNotificationSave, actionNotificationMarkSeen
} from '../../store/notifications/actions';

import {t} from "../../core/localization";
import NotificationsService from "../../services/NotificationsService";
import {Document} from "../../models/Document";
import {FormatTypes} from "../../core/Formater";
import {documentsStatusMap} from "../../dms/definitions/BaseDocument";
import {FinanceType} from "../../models/CustomerFinances";

export interface NotificationsTabProps {
	notifications: Notification[]
	tab: Tab
}

export interface NotificationsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		notifications: state.notifications.list,
		tab: state.tabs.active
	};
}

class NotificationsTab extends React.Component<NotificationsTabProps, NotificationsTabState> {

	constructor(props: NotificationsTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: NotificationsTabProps) {
	}

	componentDidMount() {
		actionNotificationFetchAll();
	}

	onOpenClick(notification: Notification) {
		const action = NotificationsService.parseAction(notification)
		actionNotificationMarkSeen(notification.id)
		if (action) {
			if (action.tabType == TabTypes.DOCUMENT_NEW) {
				let documentToRelaod = new Document()
				documentToRelaod.id = action.id
				TabsService.createTab(notification.data? Document.getTitle(notification.data): notification.title, action.tabType, documentToRelaod)
			} else {
				TabsService.createTab(notification.title, action.tabType, {id: action.id})
			}
		}
	}

	onCopyClick(notification: Notification){
		TabsService.createTab(t.Notification + ' ' + notification.title, TabTypes.NOTIFICATIONS_NEW, { ...notification, id: null })
	}

	onDeleteClick(notification: Notification){
		actionNotificationDelete(notification);
	}

	onActionDeleteClick(notifications: Notification[]){
		actionDeleteNotifications(notifications);
	}

	render(): React.ReactNode {

		const {notifications} = this.props;

		const statusMap:any = documentsStatusMap

		const columns = [
			new ColumnData<Notification>('Datum', "createdAt", null, null, FormatTypes.DATE ),
			new ColumnData<Notification>(t.Name, "title" ),
			new ColumnData<Notification>(t.Description, "description" ),
			new ColumnData<Notification>('Tip', "data", null, 'type' ),
			new ColumnData<Notification>('Status', "data", statusMap, 'state' ),
			new ColumnData<Notification>(t.Seen, 'seen', { 'true': 'da', 'false': 'ne'})
		];

		return (
			<div style={{padding: '10px'}}>
				{/*<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewNotification}</Button></div>*/}
				<NotificationList
					columns={columns}
					items={notifications}
					title={t.Notifications}
					onOpenClick={(notification: Notification) => {
						this.onOpenClick(notification)
					}}
					onCopyClick={(notification: Notification) => this.onCopyClick(notification)}
					onDeleteClick={(notification: Notification) => this.onDeleteClick(notification)}
					onActionDeleteClick={(notifications: Notification[]) => this.onActionDeleteClick(notifications)}
					tab={this.props.tab}
					descriptor={NotificationDescriptor}
					rowStyle={(rowData) => {
						if (rowData.seen) {
							return {backgroundColor: '#E0F1FF'};
						}
						else {
							return {backgroundColor: '#FFEDCB'};
						}
						return {}
					}}
				/>
			</div>
		);
	}

	onNewClick() {
		// TabsService.createTab(t.NewNotification, TabTypes.NOTIFICATIONS_NEW, new Notification())
	}
}

export default connect(mapStateToProps)(NotificationsTab);

